var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1048 29.5208L26.3132 32.7292L19.8965 39.1458C15.4667 43.5756 8.2846 43.5756 3.85482 39.1458C-0.574966 34.716 -0.574967 27.534 3.85482 23.1042L10.2715 16.6875L13.4798 19.8958L7.06315 26.3125C4.40528 28.9704 4.40528 33.2796 7.06315 35.9375C9.72102 38.5954 14.0303 38.5954 16.6882 35.9375L23.1048 29.5208ZM19.8965 13.4792L16.6882 10.2708L23.1048 3.85417C27.5346 -0.575613 34.7167 -0.575613 39.1465 3.85417C43.5763 8.28395 43.5763 15.4661 39.1465 19.8958L32.7298 26.3125L29.5215 23.1042L35.9382 16.6875C38.596 14.0296 38.596 9.72038 35.9381 7.06251C33.2803 4.40463 28.971 4.40463 26.3132 7.0625L19.8965 13.4792ZM27.9173 11.875L11.8757 27.9167L15.084 31.125L31.1257 15.0833L27.9173 11.875Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkAlt);
export default __webpack_public_path__ + "static/media/link-alt.13ffd718.svg";
export { ForwardRef as ReactComponent };